import { cloneDeep, get } from 'lodash';
import { DiscountValueType } from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/AtDiscountValue';
import { Recurrence } from '../../Components/RecurrenceRange';
import { EFrequencyUnit } from './Frequency';

const symbol = '+++';
const generateName = (p, c) => {
  return `${p}${symbol}${c}`;
};
// const getName = (name) => {
//   const [parent, child] = name.split(symbol);
//   return { child, parent };
// };

const _integerGift = (data) => {
  const { salesChannelProductList, productQuantity } = data || {};

  const dict = (productQuantity || []).reduce((pre, now) => {
    const { children, quantity, uuid } = now;
    if (children && (children || []).length > 0) {
      const cData = children.reduce((cPre, cNow) => {
        const { uuid: childUuid, quantity: childQuantity } = cNow;
        const name = generateName(uuid, childUuid);

        return {
          ...cPre,
          [name]: childQuantity,
        };
      }, {});

      return { ...pre, ...cData };
    }
    return { ...pre, [uuid]: quantity };
  }, []);

  const _salesChannelProductList = (salesChannelProductList || []).reduce(
    (pre, now) => {
      const { children, uuid } = now;

      if (children && (children || []).length > 0) {
        const _children = children.map((i) => {
          const { uuid: cUuid } = i;
          const _name = generateName(uuid, cUuid);
          const q = dict[_name] || 1;
          return { ...i, quantity: q };
        });

        return [...pre, { ...now, children: _children }];
      } else {
        const quantity = dict[uuid] || 1;
        return [...pre, { ...now, quantity }];
      }
    },
    [],
  );

  return { gifts: _salesChannelProductList };
};

const _separateGift = (data) => {
  const salesChannelProductList = cloneDeep(data || []);
  const productQuantity = (data || []).map((i) => {
    const { uuid, quantity, children } = i;
    if (children && (children || []).length > 0) {
      const _children = children.map((child) => {
        const { quantity, uuid: cUuid } = child;
        return { uuid: cUuid, quantity };
      });
      return { uuid, children: _children };
    } else {
      return {
        uuid,
        quantity,
      };
    }
  });
  return {
    salesChannelProductList,
    productQuantity,
  };
};

const convertDataFromServer = (data) => {
  const _data = cloneDeep(data || {});
  // const applyToDifferentDiscount = get(_data, 'applyToDifferentDiscount');
  const frequencies = get(_data, 'frequencies') || [];
  if (frequencies.length > 0) {
    const _frequencies = frequencies.map((fre) => {
      const discount = get(fre, 'discount');
      const orderCount = get(fre, 'orderCount', 0);
      const recurrence =
        orderCount > 0 ? Recurrence.EndAfter : Recurrence.NoEndDate;
      const _gift = get(discount, 'gifts') || {};
      // console.log('_gift', _gift);
      const temp = _integerGift(_gift);
      // console.log(temp);
      return {
        ...fre,
        orderCount,
        recurrence,
        discount: { ...(discount || {}), ...temp },
      };
      //
    });
    _data.frequencies = _frequencies;
  } else {
    _data.frequencies = [
      {
        recommended: true,
        frequency: 1,
        orderCount: 0,
        recurrence: Recurrence.NoEndDate,
        frequencyUnit: EFrequencyUnit.Days,
        discount: {
          type: DiscountValueType.Percentage,
        },
      },
    ];
  }

  const gifts = get(_data, 'subscriptionBuyDiscount.gifts') || {};
  const _salesChannelProductList = _integerGift(gifts).gifts;

  (_data.subscriptionBuyDiscount || {}).gifts = _salesChannelProductList;
  //console.log('_data', _data);
  return _data;
};

const convertDataFromState = (data, currency) => {
  const _data = cloneDeep(data);
  const frequencies = get(_data, 'frequencies') || [];
  const _frequencies = frequencies.map((fre) => {
    const discount = get(fre, 'discount');
    const _gift = get(discount, 'gifts') || [];
    const { salesChannelProductList, productQuantity } = _separateGift(
      _gift || [],
    );
    const orderCount =
      fre.recurrence === Recurrence.NoEndDate ? 0 : fre.orderCount;
    delete fre.recurrence;

    return {
      ...fre,
      orderCount: orderCount,
      discount: {
        ...(discount || {}),
        gifts: { salesChannelProductList, productQuantity },
        currency,
      },
    };
    //
  });
  _data.frequencies = _frequencies;

  const gifts = get(_data, 'subscriptionBuyDiscount.gifts') || [];
  const { salesChannelProductList, productQuantity } = _separateGift(gifts);

  _data.subscriptionBuyDiscount = {
    ...(_data.subscriptionBuyDiscount || {}),
    currency,
    gifts: {
      salesChannelProductList,
      productQuantity,
    },
  };
  //  .gifts = ;

  return _data;
};

export { convertDataFromServer, convertDataFromState };
